<div class="content" role="main" [attr.aria-busy]="!loaded()">
  @if (showNavbar() && loaded()) {
    <div class="height-saver"></div>
  }
  @if (showNavbar() && loaded()) {
    <mat-toolbar>
      <div class="toolbar-content">
        <div class="menu-container">
          @if (dataStore.selectedOrganisation) {
            <button
              mat-button
              [matMenuTriggerFor]="dataStore.isMemberOfMultipleOrgs ? orgMenu : ''"
              [attr.aria-label]="
                dataStore.isMemberOfMultipleOrgs
                  ? 'Organisatiemenu openen. Huidige organisatie: ' + dataStore.selectedOrganisation.name
                  : 'Huidige organisatie: ' + dataStore.selectedOrganisation.name
              "
              class="menu-button"
            >
              <div class="menu-item-info">
                <div class="avatar-placeholder">
                  {{ dataStore.selectedOrganisation.name[0] }}
                </div>
                <span class="menu-text">
                  {{ dataStore.selectedOrganisation.name }}
                </span>
                @if (dataStore.isMemberOfMultipleOrgs) {
                  <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
                }
              </div>
            </button>
          }
          <mat-menu #orgMenu="matMenu" [overlapTrigger]="false">
            @for (org of dataStore.rootUser.organisations; track org) {
              <button (click)="setOrganisation(org.id)" class="menu-button" mat-menu-item>
                <div class="button-wrapper">
                  <div class="avatar-placeholder small-placeholder">
                    {{ org.name[0] }}
                  </div>
                  <span>{{ org.name }}</span>
                </div>
              </button>
            }
          </mat-menu>
        </div>
        <div class="menu-container">
          <button mat-button [matMenuTriggerFor]="userMenu" aria-label="Gebruikersmenu openen" class="menu-button">
            <div class="menu-item-info">
              <div class="avatar-placeholder avatar-user">
                {{
                  dataStore?.orgUser?.name
                    ? dataStore?.orgUser?.name[0]
                    : dataStore?.rootUser?.email
                      ? dataStore?.rootUser?.email[0]
                      : ''
                }}
              </div>
              @if (dataStore.rootUser.signInMethod === 'email') {
                <span class="menu-text">
                  {{ dataStore.rootUser.email }}
                </span>
              }
              @if (dataStore.rootUser.signInMethod === 'phoneNumber') {
                <span class="menu-text">
                  {{ dataStore.rootUser.phoneNumber }}
                </span>
              }
              @if (dataStore.rootUser.signInMethod === 'google') {
                <span class="menu-text">
                  {{ dataStore.rootUser.email ?? dataStore.rootUser.phoneNumber }}
                </span>
              }
              <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
            </div>
          </button>
          <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
            @if (myProfileButton()) {
              <button class="menu-button" mat-menu-item routerLink="/profile">
                <mat-icon>account_circle</mat-icon>
                <span>Mijn profiel</span>
              </button>
            }
            <button class="menu-button" mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>Afmelden</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar>
  }
  @if (loaded()) {
    <router-outlet></router-outlet>
  }
  @if (!loaded()) {
    <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }
</div>
